import client from '/src/services/client.js';
// Endpoint api bots
export default {
    createCategory: (bot_id,data) => client.post(`bot/${bot_id}/category`,data),
    updateCategory : (bot_id,id,data) => client.put(`bot/${bot_id}/category/${id}`,data),
    deleteCategory: (bot_id,id,data) => client.delete(`bot/${bot_id}/category/${id}`,data),

    getPositionsCategories : (bot_id,data) => client.post(`bot/${bot_id}/categories/positions`,data),
    addBlocksInCategory : (bot_id,id,data) => client.post(`bot/${bot_id}/category/${id}/add`,data),
    substractBlocksFromCategory : (bot_id,category_id,id,data) => client.delete(`bot/${bot_id}/category/${category_id}/substract/${id}`,data),
}